import styled from 'styled-components';


export const Container = styled.div`
  display: flex;
  justify-content: center;

  position: relative;
  top: 0;
  padding: 0 50px;

  height: 80px;
  margin-bottom: 20px;

  background-color: #FFF;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05), 0px 6px 12px rgba(61, 69, 67, 0.05);

  > div {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    position: relative;

    width: 100%;
    margin: 0 auto;
    max-width: 500px;

    > div {
      position: absolute;
      left: 30px;
    }

    @media screen and (max-width: 766px) {
      max-width: 420px;

      > div {
        left: -15px;
      }
    }

  }
`;


